const CountryExposureChart = require('okCharts/CountryExposureChart');

module.exports = CountryExposureChart;
